module.exports = __webpack_public_path__ + "media/base/subcontractors_big-fe887c5e.svg";